// 直播管理
export default [
  {
    path: "/liveManage",
    name: "liveManage",
    meta: { title: "直播管理" },
    component: () => import("../views/liveManage/index"),
    children: [
      {
        path: "/liveManage/liveList",
        meta: { title: "直播列表", isMenu: true },
        component: () => import("../views/liveManage/liveList"),
      },
      {
        path: "/liveManage/detail/liveInfo",
        meta: { title: "直播详情", isMenu: true },
        component: () => import("../views/liveManage/detail/liveInfo"),
      },
      {
        path: "/liveManage/detail/applyLive",
        meta: { title: "新增直播", isMenu: true },
        component: () => import("../views/liveManage/detail/applyLive"),
      },
      {
        path: "/liveManage/detail/afterClassQA",
        meta: { title: "课后问答", isMenu: true },
        component: () => import("../views/liveManage/detail/afterClassQA"),
      },
      {
        path: "/liveManage/categoryList",
        meta: { title: "直播分类", isMenu: true },
        component: () => import("../views/liveManage/categoryList"),
      },
    ],
  },
]
